const items = [
	{
		id: 1,
		key: 1,
		name: "status.active"
	},
	{
		id: 0,
		key: 0,
		name: "status.rejectedLife"
	},
	{
		id: 2,
		key: 2,
		name: "status.clame"
	},
	{
		id: 3,
		key: 3,
		name: "status.indebt"
	},
];

export default items;